import BaseService from './BaseService.js'

export default {
  login(email, password) {
    return BaseService.post('Account/Login', { email, password })
  },
  logout() {
    return BaseService.post('Account/Logout')
  },
  register(user) {
    return BaseService.post('Account/Register', user)
  },
  updateUser(user) {
    return BaseService.post('Account/Update', user)
  },
  getInfo() {
    return BaseService.get('Account/Info')
  },
  updatePassword(user) {
    return BaseService.post('Account/UpdatePassword', user)
  },
  updateEmail(user) {
    return BaseService.post('Account/UpdateEmail', user)
  },
  forgotPassword(email) {
    return BaseService.post('Account/ForgotPassword', { email })
  },
  resetPassword(email, password, token) {
    return BaseService.post('Account/ResetPassword', { email, password, token })
  }
}
